// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/hero/hero.component.scss
// module id = 212
// module chunks = 0